import _ from 'lodash';
import { sqWorkbenchStore } from '@/core/core.stores';
import { sqSystemApi } from '@/sdk/api/SystemApi';
import type { AddOnToolOutputV1 } from '@/sdk/model/AddOnToolOutputV1';

export function loadHomeScreenAddOnTools(): Promise<AddOnToolOutputV1[]> {
  return sqSystemApi.getAddOnTools().then(({ data: { addOnTools } }) => {
    const myUserId = sqWorkbenchStore.currentUser.id;
    // We don't want admins to see all addOns on the system, just relevant ones
    return _.filter(addOnTools, (addOnTool) => {
      return !addOnTool.inDevelopment || addOnTool?.installer?.id === myUserId;
    });
  });
}
